import { useContext } from 'react';
import { OrdersListContext } from './orders-list-context';

export const useOrdersListContext = () => useContext(OrdersListContext);
